module.exports = __webpack_public_path__ + "media/images/badge__editors-choice--medium-c2589c24d12a41d501208d623f524c11.svg";